<script>
  import Card from "../shared/Card.svelte";
  import Button from "../shared/Button.svelte";
  import Lesson from "../shared/Lesson.svelte";
  import { _ } from "svelte-i18n";

  import { getContext } from 'svelte';
  const { open } = getContext('simple-modal');
  const openModal = () => {
    open(Lesson, {component: lesson.component});
  }

  export let lesson;
  export let locale_title;
  export let locale_desc;
</script>

<Card>
  <div class="lesson">
    <img src={lesson.img} alt="" class="unselectable" />
    <h3>{locale_title}</h3>
    <p>{locale_desc}</p>
    <div class="start">
      <Button flat={true} inverse={true} on:click={openModal}>{$_("button-0")}</Button>
    </div>
  </div>
</Card>

<style>
  img {
    width: 100%;
  }
  h3 {
    margin: 0 auto;
    margin-top: 10px;
    color: #333;
  }
  p {
    margin-top: 6px;
    font-size: 14px;
    color: #888;
    margin-bottom: 20px;
  }
  .start {
    margin-bottom: 0px;
    text-align: center;
  }
</style>
